import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common";
import { operationCardSchemaObject } from '../../Data';
import { PageHeader } from '../../../Common/pageHeader';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi';
import groupService from '../../Group/services';
import collectionCategoryService from '../../CollectionCategory/services';
import fieldsService from '../../Field/services'
import { MenuItem } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'OPERATIONCARD';


export function OperationCardAddEdit(props) {

    const { data, edit } = props.location
    const [title, setTitle] = useState("Add Operation Card")
    const [buttonName, setButtonName] = useState("Save")
    const [groups, setGroups] = useState()
    const [isChanged, setIsChanged] = useState(0);
    const [operationEntity, setOperationEntity] = useState();
    const [collectionPoints, setCollectionPoints] = useState()
    const [collectionCategory, setCollectionCategory] = useState();
    const [collectionPointData, setCollectionPointData] = useState();
    const [operationCard, setOperationCard] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionCatagoryID: "0",
        collectionPointID: "0",
    });
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const [buttonHide, setButtonHide] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(operationCardSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        if (data && edit) {
            setTitle("View Operation Card")
            setButtonHide(true);
            setOperationCardValuesForEditScreen()
        } else {
            setTitle("Add Operation Card")
        }
    }, [])

    useEffect(() => {
        if(!edit){
            setIsChanged(isChanged + 1);
        }
    }, [operationCard]);

    useEffect(() => {
        trackPromise(
            getOperationEntities()
            )
    }, [operationCard.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
            )
        getCollectionPointDropDownItems();
    }, [operationCard.operationEntityID]);

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITOPERATIONCARD');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });
        
        if (data && edit) {
            setOperationCard(data);
            setButtonName("Update");
            setTitle("View Operation Card")
            setButtonHide(true);
            setOperationCardValuesForEditScreen()
        } else {
            setTitle("Add Operation Card");
            var token = tokenService.getUserDetailsFromToken();
            setOperationCard({
                ...operationCard,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            getGroupDropdownData()
        )
    }

    async function setOperationCardValuesForEditScreen() {
        let collectionPointData = await fieldsService.getCollectionPointByID(data.collectionPointID);
        
        const selectedOperationEntity = await services.getOperationEntityByType(collectionPointData.operationEntityTypeID.toString(), collectionPointData.groupID.toString());
        setOperationEntity(selectedOperationEntity);

        if(data.collectionPointID != 0){
            const collectionPoint = await services
                .GetAllCollectionPoints(collectionPointData.operationEntityID.toString(), data.collectionPointID);
            setCollectionPoints(collectionPoint);
        }

        const collectionCategories = await collectionCategoryService.GetCollectionCategoryByOperationEntityID(collectionPointData.operationEntityID.toString());
        setCollectionCategory(collectionCategories);

        setOperationCard({
            ...operationCard,
            groupID: collectionPointData.groupID.toString(),
            operationEntityTypeID: collectionPointData.operationEntityTypeID.toString(),
            operationEntityID: collectionPointData.operationEntityID.toString(),
            collectionPointID: data.collectionPointID.toString(),
            collectionCatagoryID: data.collectionCategoryID.toString(),
        })
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategories = await collectionCategoryService.GetCollectionCategoryByOperationEntityID(operationCard.operationEntityID);
        setCollectionCategory(collectionCategories);
    }

    async function getOperationEntities() {
        const selectedOperationEntity = await services.getFactoriesByGroupID(operationCard.groupID);
        setOperationEntity(selectedOperationEntity);
    }

    async function getGroupDropdownData() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getCollectionPointDropDownItems() {
        var collectionPointID = (data === undefined ? 0 : data.collectionPointID);
        const collectionPoint = await services.GetAllCollectionPoints(operationCard.operationEntityID, collectionPointID);
        setCollectionPoints(collectionPoint);
    }

    async function handleSave(e) {
        e.preventDefault()

        const errorMessages = validate(schema, operationCard)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return

        if (!edit) {
            const response = await services.saveOperationCard(operationCard)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        } else if (edit) {
            const response = await services.editData(operationCard)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/operationcards' })
            }, 1500);
        }
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setOperationCard({
            ...operationCard,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityTypeID: "0",
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionCatagoryID: "0",
            collectionPointID: "0",
        })
    }

    function onCancelClick() {
        clearState()
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function handleGroupChange(target){
        validateInputs(target);

        setOperationCard({
            groupID: target.value,
            operationEntityTypeID: "0",
            operationEntityID: "0",
            collectionCatagoryID: "0",
            collectionPointID: "0",
        });
    }

    function handleOperationEntityChange(target){
        validateInputs(target);

        setOperationCard({
            ...operationCard,
            operationEntityID: target.value,
            collectionCatagoryID: "0",
            collectionPointID: "0",
        });
    }

    function handleCollectionPointChange(target){
        validateInputs(target);

        setOperationCard({
            ...operationCard,
            collectionPointID: target.value,
        });
    }

    function handleCollectionCategoryChange(target){
        validateInputs(target);

        setOperationCard({
            ...operationCard,
            collectionCatagoryID: target.value,
        });
    }

    function validateInputs(target){
        const error = { ...errors }
        const errorMessage = validateProperty(target, operationCardSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setErrors(error);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/operationcards"
                                    isChanged={isChanged}
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSave(e)}>

                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            disabled={edit || !permissionList.isGroupFilterEnabled}
                                            id="groupID"
                                            name="groupID"
                                            value={operationCard.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            disabled={edit || !permissionList.isGroupFilterEnabled}
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={operationCard.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionPointID">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            disabled={edit}
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={operationCard.collectionPointID}
                                            onChange={(e) => handleCollectionPointChange(e.target)}>
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(collectionPoints)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionCatagoryID">Collection Catagory *</InputLabel>
                                        <Select
                                            fullWidth
                                            disabled={edit}
                                            id="collectionCatagoryID"
                                            name="collectionCatagoryID"
                                            value={operationCard.collectionCatagoryID}
                                            onChange={(e) => handleCollectionCategoryChange(e.target)}>
                                            <MenuItem value="0">--Select Collection Catagory--</MenuItem>
                                            {generateDropDownMenu(collectionCategory)}
                                        </Select>
                                        {errors["collectionCatagoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionCatagoryID"]}</FormHelperText>}
                                    </div>
                                </div>


                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, operationCard)}
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonName}
                                        hidden={buttonHide}
                                    />
                               
                                    <input
                                      type="button"
                                      className="btn btn-warning pull-right"
                                      value="Clear"
                                      onClick={onCancelClick}
                                      hidden={buttonHide}
                                    />
                                </div>


                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}